import { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, InputGroup, Modal, Badge, OverlayTrigger, Tooltip} from "react-bootstrap";
import { FaPlus, FaRegEdit,FaEdit, FaTrash, FaSearch, FaEye, FaFile, FaCheck, FaTimes, FaDownload, FaExclamationTriangle } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm,
         formataDataHoraExibicao,
         getCurrentUser,
         situacoesAgendamento,
         formataDataExibicao,
         tiposArquivos,
         isLaudoBloqueadoParaUsuarioAtual }
         from '../../common/utils';
import Paginacao from '../../common/pagination';
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { getConfig } from '../../common/config';
import ConfirmarRealizacaoModal from '../Modals/ConfirmarRealizacaoModal';
import ModalPersonalizadoServicos from '../Modals/ModalPersonalizadoServicos';
import { debounce } from 'lodash';

class Agendamentos extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            beneficiario_id: "",
            page_numb: 1,
            dados_usuario: '',
            loading: true,
            showConfirmarRealizacaoModal: false,
            agendamentoParaConfirmar: null,
            showModalPersonalizadoServicos: false,
            agendamentoFormularioDinamico: null,
            showModalArquivos: false,
            arquivos: [],
            agendamento_selecionado: null,
            agendamento_selecionado: null,
            loadingArquivos: false,
            // Upload states
            showModalArquivosEdit: false,
            arquivo_id: null,
            arquivo_upload: null,
            arquivo_nome: '',
            arquivo_tipo: '',
            arquivoHelper: '',
        };

        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        
        this.debouncedConsulta = debounce((termoBusca) => {
            this.consultaRegistro(this.state.beneficiario_id, 1, termoBusca);
        }, 600);
    }

    componentDidMount(){
        this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb, "");
    }

    consultaRegistro(beneficiario_id, page_numb = 1, search = ""){
        const dados_user = getCurrentUser();
        
        const termoBusca = search !== undefined ? search : this.state.busca;

        this.setState({
            dados_usuario: dados_user,
            loading: true,
            page_numb: page_numb
        });

        let url = `/agendamentos/?page=${page_numb}`;

        if (dados_user['tipo_usuario'] && ['prestador', 'operador', 'beneficiario'].includes(dados_user['tipo_usuario'])) {
             url += `&tipo_usuario=${dados_user['tipo_usuario']}`;
        }

        if (beneficiario_id) {
            url += `&beneficiario_id=${beneficiario_id}`;
        }

        if (termoBusca) {
            url += `&search=${encodeURIComponent(termoBusca)}`;
        }

        if (this.state.data_inicio) url += `&data_inicio=${this.state.data_inicio}`;
        if (this.state.data_fim) url += `&data_fim=${this.state.data_fim}`;

        const programa_id = dados_user['ambiente_programa_id'] || '';

        url += `&programa_id=${programa_id}`;

        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar os agendamentos, tente novamente.';

            if(error.response){
                if(error.response.status === 500) erro_msg = 'Servidor indisponível no momento';
                else if(error.response.status === 403) erro_msg = 'Você não tem permissão para acessar essa área';
                else if(error.response.status === 404) erro_msg = 'Recurso não encontrado (Verifique a URL)';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }


    /**
     * Gera o HTML dos campos dinâmicos baseado na configuração
     * @param {Array} campos - Array de configuração de campos
     * @returns {string} HTML gerado
     */
    gerarHtmlCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos)) return '';

        return campos.map(campo => {
            const obrigatorioMark = campo.obrigatorio ? '<span class="text-danger">*</span>' : '';
            const observacao = campo.observacao ? `<small class="text-muted d-block mt-1">${campo.observacao}</small>` : '';

            switch (campo.tipo) {
                case 'file':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="file" 
                                accept="${campo.extensoes || '.pdf,.jpg,.jpeg,.png'}"
                                class="swal2-file form-control" 
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'radio': {
                    const opcoesHtml = (campo.opcoes || []).map((opcao, idx) => {
                        const descricao = campo.descricoes_opcoes?.[opcao] 
                            ? `<small class="text-muted d-block ms-4">${campo.descricoes_opcoes[opcao]}</small>` 
                            : '';
                        return `
                            <div class="form-check">
                                <input 
                                    class="form-check-input" 
                                    type="radio" 
                                    name="swal-campo-${campo.slug}" 
                                    id="swal-campo-${campo.slug}-${idx}" 
                                    value="${opcao}"
                                    data-slug="${campo.slug}"
                                    data-tipo="${campo.tipo}"
                                />
                                <label class="form-check-label" for="swal-campo-${campo.slug}-${idx}">${opcao}</label>
                                ${descricao}
                            </div>
                        `;
                    }).join('');
                    
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label class="text-start d-block mb-2">${campo.label} ${obrigatorioMark}</label>
                            <div class="text-start" data-obrigatorio="${campo.obrigatorio || false}" data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'>
                                ${opcoesHtml}
                            </div>
                            ${observacao}
                        </div>
                    `;
                }
                
                case 'text':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="text" 
                                class="swal2-input" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'textarea':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <textarea 
                                id="swal-campo-${campo.slug}" 
                                class="swal2-textarea" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            ></textarea>
                            ${observacao}
                        </div>
                    `;
                
                default:
                    return '';
            }
        }).join('');
    };

    /**
     * Configura event listeners para campos com obrigatoriedade condicional
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    configurarEventosCamposDinamicos = (container, campos) => {
        if (!campos || !Array.isArray(campos)) return;

        campos.forEach(campo => {
            if (campo.tipo === 'radio') {
                const radios = container.querySelectorAll(`input[name="swal-campo-${campo.slug}"]`);
                radios.forEach(radio => {
                    radio.addEventListener('change', () => {
                        this.atualizarObrigatoriedadeCondicional(container, campos);
                    });
                });
            }
        });
    };

    /**
     * Atualiza a obrigatoriedade condicional dos campos baseado nos valores selecionados
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    atualizarObrigatoriedadeCondicional = (container, campos) => {
        campos.forEach(campo => {
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = container.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                
                const elementoCampo = container.querySelector(`#swal-campo-${campo.slug}`);
                const containerCampo = container.querySelector(`.campo-dinamico[data-slug="${campo.slug}"]`);
                
                if (elementoCampo && containerCampo) {
                    const isObrigatorio = valores.includes(valorAtual);
                    const labelEl = containerCampo.querySelector('label');
                    
                    if (labelEl) {
                        const spanObrig = labelEl.querySelector('.text-danger');
                        if (isObrigatorio && !spanObrig) {
                            labelEl.innerHTML = labelEl.textContent + ' <span class="text-danger">*</span>';
                        } else if (!isObrigatorio && spanObrig) {
                            spanObrig.remove();
                        }
                    }
                    
                    elementoCampo.dataset.obrigatorioAtual = isObrigatorio;
                }
            }
        });
    };

    /**
     * Coleta os valores de todos os campos dinâmicos
     * @param {Array} campos - Array de configuração de campos
     * @returns {Object} Objeto com slugs como chaves e valores preenchidos
     */
    coletarValoresCamposDinamicos = (campos) => {
        const valores = {};
        const arquivos = {};
        
        if (!campos || !Array.isArray(campos)) {
            return { valores, arquivos };
        }

        campos.forEach(campo => {
            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (fileInput?.files?.length > 0) {
                        arquivos[campo.slug] = fileInput.files[0];
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (radioSelecionado) {
                        valores[campo.slug] = radioSelecionado.value;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (inputEl) {
                        valores[campo.slug] = inputEl.value.trim();
                    }
                    break;
                }
            }
        });

        return { valores, arquivos };
    };

    /**
     * Valida os campos dinâmicos obrigatórios
     * @param {Array} campos - Array de configuração de campos
     * @returns {string|null} Mensagem de erro ou null se válido
     */
    validarCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos)) {
            return null;
        }

        for (const campo of campos) {
            let isObrigatorio = campo.obrigatorio === true;
            
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = document.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                isObrigatorio = valores.includes(valorAtual);
            }

            if (!isObrigatorio) continue;

            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!fileInput?.files?.length) {
                        return `Por favor, selecione um arquivo para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (!radioSelecionado) {
                        return `Por favor, selecione uma opção para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!inputEl?.value?.trim()) {
                        return `Por favor, preencha o campo "${campo.label}"`;
                    }
                    break;
                }
            }
        }

        return null;
    };

    handleConfirmarServico = (agendamento) => {
        // Check if new modal should be used
        const useNewModal = getConfig(
            agendamento?.dados_programa?.configuracoes, 
            'show_modal_confirm_service', 
            false
        );
        
        if (useNewModal) {
            this.setState({
                showConfirmarRealizacaoModal: true,
                agendamentoParaConfirmar: agendamento,
            });
            return;
        }
        
        const MySwal = withReactContent(Swal);
        const dataRealizacaoPadrao = moment().tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm');
        
        const configuracoesServico = agendamento?.dados_servico_procedimento?.configuracoes;
        const camposDinamicos = configuracoesServico?.modal_confirmacao?.campos || [];
        const temCamposDinamicos = camposDinamicos.length > 0;
        
        const htmlCamposDinamicos = temCamposDinamicos 
            ? `<div class="campos-dinamicos-container mt-3 pt-3 border-top">${this.gerarHtmlCamposDinamicos(camposDinamicos)}</div>`
            : '';

        MySwal.fire({
            title: 'Confirmar Realização',
            icon: 'warning',
            html: `
                <div class="text-start container-confirma-servico" style="max-height: 65vh; overflow-y: auto; overflow-x: hidden; padding-right: 10px;">
                <p class="text-start">Deseja confirmar a realização de <strong>${agendamento.dados_servico_procedimento.nome}</strong>?</p>

                <label for="swal-input-data" class="text-start">Data de Realização do Serviço</label>
                <input id="swal-input-data" type="datetime-local"
                    value="${dataRealizacaoPadrao}"
                    min="${moment().subtract(30, 'days').format('YYYY-MM-DDTHH:mm')}"
                    max="${moment().format('YYYY-MM-DDTHH:mm')}"
                    class="swal2-input swal-input-data" />

                <label for="swal-textarea-anotacoes" class="text-start mt-3">Anotações do Serviço (opcional)</label>
                <textarea id="swal-textarea-anotacoes" class="swal2-textarea swal-textarea-anotacoes"></textarea>
                
                ${htmlCamposDinamicos}
                </div>
            `,
            width: temCamposDinamicos ? '800px' : '650px',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',
            didOpen: (el) => {
                if (temCamposDinamicos) {
                    this.configurarEventosCamposDinamicos(el, camposDinamicos);
                }
            },
            preConfirm: () => {
                const data = document.getElementById('swal-input-data').value;
                const anotacoes = document.getElementById('swal-textarea-anotacoes').value;

                if (!data) {
                    Swal.showValidationMessage('Por favor, selecione uma data de realização');
                    return false;
                }
                
                if (temCamposDinamicos) {
                    const erroValidacao = this.validarCamposDinamicos(camposDinamicos);
                    if (erroValidacao) {
                        Swal.showValidationMessage(erroValidacao);
                        return false;
                    }
                }
                
                const dadosDinamicos = temCamposDinamicos 
                    ? this.coletarValoresCamposDinamicos(camposDinamicos)
                    : { valores: {}, arquivos: {} };

                return { 
                    data, 
                    anotacoes,
                    dadosConfirmacao: dadosDinamicos.valores,
                    arquivosConfirmacao: dadosDinamicos.arquivos
                };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const dataRealizacao = moment(result.value.data).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss');
                const anotacoes = result.value.anotacoes;
                const dadosConfirmacao = result.value.dadosConfirmacao;
                const arquivosConfirmacao = result.value.arquivosConfirmacao;

                const payload = {
                    data_realizacao: dataRealizacao,
                    adicionar_servico_atendimento: true,
                    situacao: 'finalizado'
                } 

                
                if (anotacoes && anotacoes.trim() !== '') {
                    payload.anotacoes = anotacoes;
                }
                
                if (temCamposDinamicos && Object.keys(dadosConfirmacao).length > 0) {
                    const dadosConfirmacaoArray = [];
                    camposDinamicos.forEach(campo => {
                        const valor = dadosConfirmacao[campo.slug];
                        if (valor !== undefined && valor !== null && valor !== "") {
                            dadosConfirmacaoArray.push({
                                slug: campo.slug,
                                label: campo.label,
                                value: valor,
                                type: campo.tipo
                            });
                        }
                    });
                    
                    if (dadosConfirmacaoArray.length > 0) {
                        payload.dados_confirmacao = dadosConfirmacaoArray;
                    }
                }

                const temArquivos = Object.keys(arquivosConfirmacao).length > 0;
                let requestPromise;

                if (temArquivos) {
                    const formData = new FormData();
                    
                    Object.entries(payload).forEach(([key, value]) => {
                        if (value !== null && value !== undefined) {
                            if (typeof value === 'object' && !(value instanceof File)) {
                                formData.append(key, JSON.stringify(value));
                            } else {
                                formData.append(key, value);
                            }
                        }
                    });

                    Object.entries(arquivosConfirmacao).forEach(([slug, arquivo]) => {
                        formData.append(`arquivo_${slug}`, arquivo);
                    });
                    
                    const arquivosKeys = Object.keys(arquivosConfirmacao);
                    if (arquivosKeys.length > 0) {
                        formData.append('arquivo_confirmacao', arquivosConfirmacao[arquivosKeys[0]]);
                    }

                    requestPromise = api.put(`/agendamentos/${agendamento.id}/`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                } else {
                    requestPromise = api.put(`/agendamentos/${agendamento.id}/`, payload);
                }

                requestPromise
                    .then(() => {
                        // Cadastrar relato após confirmar o agendamento
                        if (agendamento.etapa_atual?.id && agendamento.atendimento_id) {
                            const formData = new FormData();

                            formData.append('data', dataRealizacao);
                            formData.append('etapa_id', agendamento.etapa_atual.id);
                            formData.append('atendimento_id', agendamento.atendimento_id);
                            formData.append('tipo', 'etapa');
                            formData.append('titulo', `Realização de ${agendamento.dados_servico_procedimento.nome}`);
                            formData.append('servico_procedimento_id', agendamento.servico_procedimento_id);
                            formData.append('ignorar_cadastro_servico', true);

                            return api.post('/atendimentos/relatos/', formData);
                        }
                        
                        return Promise.resolve(); // Continua a chain mesmo sem cadastrar relato
                    })
                    .then(() => {
                        MySwal.fire({
                            title: 'Sucesso!',
                            text: 'Realização de serviço confirmado com sucesso.',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        }).then((result) => {
                            window.location.reload(); 
                        });
                    })
                    .catch((error) => {
                        const errorMessage =
                            error.response && error.response.data
                                ? error.response.data.message || 'Erro ao confirmar o serviço ou registrar o relato.'
                                : 'Erro ao confirmar o serviço ou registrar o relato.';
                        MySwal.fire({
                            title: 'Erro!',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                        });
                    });
    
            }
        });
    };

    /**
     * Abre o modal de formulário dinâmico para serviços
     */
    handleEnviaCadastroFormularioDinamico = (agendamento) => {
        this.setState({
            showModalPersonalizadoServicos: true,
            agendamentoFormularioDinamico: agendamento,
        });
    };

    /**
     * Verifica se deve mostrar o botão de formulário dinâmico para o agendamento
     */
    deveMostrarBotaoFormularioDinamico = (agendamento) => {
        const configFormulario = agendamento?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        if (!configFormulario) return false;
        
        const showOnEtapa = configFormulario.show_on_etapa;
        const etapaAtualNome = agendamento?.etapa_atual?.nome;
        
        // Se não tem restrição de etapa, mostra sempre
        if (!showOnEtapa || !Array.isArray(showOnEtapa)) return true;
        
        // Verifica se a etapa atual está na lista de etapas permitidas
        return showOnEtapa.includes(etapaAtualNome);
    };

    /**
     * Retorna o título do botão de formulário dinâmico
     */
    getTituloBotaoFormularioDinamico = (agendamento) => {
        const configFormulario = agendamento?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        return configFormulario?.titulo_botao || 'Formulário';
    };

    handleShowModalArquivos = (agendamento) => {
        this.carregaArquivosAgendamento(agendamento.id);
        this.setState({ showModalArquivos: true, agendamento_selecionado: agendamento });
    };

    handleCloseModalArquivos = () => {
        this.setState({ showModalArquivos: false, arquivos: [], agendamento_selecionado: null });
    };

    carregaArquivosAgendamento = (agendamento_id) => {
        this.setState({ loadingArquivos: true });
        api.get(`/agendamentos/arquivos/?agendamento_id=${agendamento_id}`)
            .then(response => {
                const arquivosCarregados = response.data.results.map(dados => ({
                    id: dados.id,
                    nome: dados.nome,
                    arquivo: dados.arquivo,
                    agendamento_id: dados.agendamento_id,
                    data: dados.data,
                    aprovado: dados.aprovado,
                    tipo: dados.tipo,
                    motivo_recusa: dados.motivo_recusa,
                    cadastrado_por_id: dados.cadastrado_por_id
                }));
                this.setState({ arquivos: arquivosCarregados, loadingArquivos: false });
            })
            .catch(error => {
                this.setState({ loadingArquivos: false });
                console.error("Erro ao carregar arquivos:", error);
            });
    };

    handleAprovarArquivo = (arquivo_id) => {
        const MySwal = withReactContent(Swal);
        
        MySwal.fire({
            title: 'Aprovar Arquivo?',
            text: "Confirmar a aprovação deste documento?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, aprovar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loadingArquivos: true });
                api.put(`/agendamentos/arquivos/${arquivo_id}/`, { aprovado: true })
                    .then(() => {
                        this.setState({ loadingArquivos: false });
                        MySwal.fire({
                            title: 'Sucesso', 
                            text: 'Arquivo aprovado.', 
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        if (this.state.agendamento_selecionado) {
                            this.carregaArquivosAgendamento(this.state.agendamento_selecionado.id);
                            this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                        }
                    })
                    .catch(error => {
                        this.setState({ loadingArquivos: false });
                        const msg = error.response?.data?.detail || 'Não foi possível aprovar.';
                        MySwal.fire('Erro', msg, 'error');
                    });
            }
        });
    }

    handleRecusarArquivo = (arquivo_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Recusar Arquivo',
            text: "Motivo da não aprovação (será enviado ao laboratório):",
            input: 'textarea',
            inputPlaceholder: 'Ex: Imagem ilegível, paciente incorreto...',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#eb4961',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Recusar e Notificar',
            inputValidator: (value) => {
                if (!value) return 'A justificativa é obrigatória!'
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                this.setState({ loadingArquivos: true });
                api.put(`/agendamentos/arquivos/${arquivo_id}/`, {
                    aprovado: false,
                    motivo_recusa: result.value
                })
                .then(() => {
                    this.setState({ loadingArquivos: false });
                    MySwal.fire({
                        title: 'Recusado', 
                        text: 'Laboratório notificado e status atualizado.', 
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    if (this.state.agendamento_selecionado) {
                        this.carregaArquivosAgendamento(this.state.agendamento_selecionado.id);
                        this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                    }
                })
                .catch(error => {
                    this.setState({ loadingArquivos: false });
                    const msg = error.response?.data?.detail || 'Erro ao processar a recusa.';
                    MySwal.fire('Erro', msg, 'error');
                });
            }
        });
    }

    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {

            return this.state.listRegistros.results.map((item) => {
                const dataAgendamento = moment(item.data_agendamento).tz("America/Sao_Paulo");
                const tolerancia = dataAgendamento.add(10, 'hours');
                const showVideoButton = true;// now.isBefore(tolerancia) && item.situacao === 'liberado';

                return (
                    <tr key={item.id}>
                        <td data-label="ID">{item.id}</td>
                        <td>{formataDataHoraExibicao(item.data_agendamento)}</td>
                        {this.state.dados_usuario['tipo_usuario'] !== 'prestador' && (
                            <td>{item.dados_prestador.nome}</td>
                        )}
                        <td>{item.dados_beneficiario.nome}{item.dados_mentorado.nome}</td>
                        <td>{item.dados_servico_procedimento.nome}</td>
                        <td>{formataDataHoraExibicao(item.data_solicitacao)}</td>
                        <td><div className="td-border"><span className={`badge-agendamento badge-status-${item.situacao}`}>{situacoesAgendamento[item.situacao]}</span></div></td>
                        <td>
                            {item.atendimento_kit_id ? (
                                <>
                                    {item.dados_atendimento_kit?.status === 'cancelado' ? (
                                        <span>Cancelado</span>
                                    ) : (
                                        <>
                                            <span>Sim</span>
                                            {item.dados_atendimento_kit.data_envio && (
                                                <p className="mb-1 p-info">Previsão: {formataDataExibicao(item.dados_atendimento_kit.data_envio)}</p>
                                            )}
                                            {item.dados_atendimento_kit.data_envio_realizado && (
                                                <p className="mb-1 p-info">Enviado em: {formataDataExibicao(item.dados_atendimento_kit.data_envio_realizado)}</p>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <span>Não</span>
                            )}
                        </td> 
                        <td>
                            {this.state.dados_usuario['tipo_usuario'] !== 'prestador' && this.state.dados_usuario['tipo_usuario'] !== 'beneficiario' && (
                                <Button variant="light" href={"/agendamentos/edit/"+item.id} size="sm">
                                    <FaRegEdit /> Editar
                                </Button>    
                            )}
                            {(this.state.dados_usuario['tipo_usuario'] === 'prestador' || this.state.dados_usuario['tipo_usuario'] === 'beneficiario') && item.dados_meeting?.whereby_sala_id && item.dados_meeting?.whereby_sala_url && showVideoButton && (
                                <Button variant="secondary" className="btn-sm" href={"/meetings/view/"+item.id} size="sm">
                                    Vídeo Conferência
                                </Button>    
                            )}
                            {item.situacao != 'finalizado' && item.situacao != 'cancelado' && item.situacao != 'arquivo_pendente' && this.state.dados_usuario['tipo_usuario'] === 'prestador' && (
                                <>
                                    <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarServico(item)}>
                                        Confirmar Realização
                                    </Button>
                                    {this.deveMostrarBotaoFormularioDinamico(item) && (
                                        <Button variant="info" size="sm" className="me-2 mb-1 mt-1 text-white" onClick={() => this.handleEnviaCadastroFormularioDinamico(item)}>
                                            <i className="fa fa-list-alt me-1"></i>
                                            {this.getTituloBotaoFormularioDinamico(item)}
                                        </Button>
                                    )}
                                </> 
                            )}
                            {item.situacao === 'arquivo_pendente' && (
                                <>
                                    {(() => {
                                        const configValidacao = getConfig(item.dados_programa?.configuracoes || item?.dados_atendimento?.programa?.configuracoes, 'agendamento.validacao_arquivos', false);
                                        const user = getCurrentUser();
                                        const podeAnalisar = ['operador', 'gestor', ''].includes(user.tipo_usuario) || (user.tipo_usuario === 'prestador' && configValidacao && user.prestador_categoria !== 'medicos');

                                        return podeAnalisar && (
                                            <Button variant="warning" size="sm" className="me-2 mb-1 mt-1 text-dark" onClick={() => this.handleShowModalArquivos(item)}>
                                                <FaFile /> Arquivos
                                            </Button>
                                        );
                                    })()}
                                </>
                            )}
                            {item.atendimento_kit_id && item.dados_atendimento_kit?.status === 'agendado' && (
                                <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarEnvioKit(item.atendimento_kit_id, item)}>
                                    Confirmar Envio Kit
                                </Button>
                            )}
                            {item.atendimento_uuid && (
                                <Button variant="light" href={"/atendimentos/edit/"+item.atendimento_uuid} size="sm">
                                    <FaEye /> Ver Atendimento
                                </Button>    
                            )}
                        </td>
                    </tr>
                );
            });
        }

        return (
            <tr>
                <td colSpan={6}>Nenhum agendamento cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        const value = e.target.value;
        this.setState({ busca: value });
        this.debouncedConsulta(value);
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, num_page);
    }

    handleConfirmarEnvioKit = (atendimento_kit_id, agendamento) => {
        const MySwal = withReactContent(Swal);
        const dataEnvioPadrao = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
    
        MySwal.fire({
            title: 'Confirmar envio do kit',
            icon: 'warning',
            html: `
                <div class="text-start container-confirma-servico">
                <p class="text-start">Deseja confirmar o envio do kit de <strong>${agendamento.dados_servico_procedimento.nome}</strong>?</p>

                <label for="swal-input-data" class="text-start">Data de Envio do kit</label>
                <input id="swal-input-data" type="date"
                    value="${dataEnvioPadrao}"
                    min="${moment().subtract(30, 'days').format('YYYY-MM-DD')}"
                    max="${moment().format('YYYY-MM-DD')}"
                    class="swal2-input swal-input-data" />
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar!',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const data = document.getElementById('swal-input-data').value;

                if (!data) {
                    Swal.showValidationMessage('Por favor, selecione uma data de envio');
                    return false;
                }

                return { data };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const dataEnvio = moment(result.value).tz('America/Sao_Paulo').format('YYYY-MM-DD');

                const payload = {
                    data_envio_realizado: dataEnvio,
                    status: 'enviado',
                } 
    
                api
                    .put(`/atendimentos/kits/${atendimento_kit_id}/`, payload)
                    .then(() => {
                        MySwal.fire({
                            title: 'Sucesso!',
                            text: 'Envio de kit confirmado com sucesso.',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        });
                        this.carregarAgendamentos(); 
                    })
                    .catch((error) => {
                        const errorMessage =
                            error.response && error.response.data
                                ? error.response.data.message || 'Erro ao confirmar o envio de kit.'
                                : 'Erro ao confirmar o envio de kit.';
                        MySwal.fire({
                            title: 'Erro!',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                        });
                    });
            }
        });
    };


    handleChange = (event, fieldName) => {
        this.setState({ [fieldName]: event.target.value });
    };

    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            this.setState({ arquivo_upload: e.target.files[0] });
            this.setState({ arquivoHelper: '' });
        }
    };

    handleShowModalArquivosEdit = () => {
        // Fecha o modal de listagem para abrir o de edição/upload
        this.setState({ 
            showModalArquivos: false,
            showModalArquivosEdit: true,
            arquivo_id: null,
            arquivo_upload: null,
            arquivo_nome: '',
            arquivo_tipo: '',
            arquivoHelper: ''
        });
    };

    handleCloseModalArquivosEdit = () => {
        // Ao fechar o modal de edição/upload, reabre o de listagem
        this.setState({ 
            showModalArquivosEdit: false,
            showModalArquivos: true 
        });
    };

    saveArquivo = (e) => {
        e.preventDefault();
        const MySwal = withReactContent(Swal);
        const { arquivo_upload, arquivo_nome, arquivo_tipo, agendamento_selecionado } = this.state;

        if (!arquivo_nome) {
            MySwal.fire({ icon: 'warning', title: 'Atenção!', text: 'Informe um nome para o arquivo' });
            return;
        }
        if (!arquivo_tipo) {
            MySwal.fire({ icon: 'warning', title: 'Atenção!', text: 'Selecione um tipo do arquivo' });
            return;
        }
        if (!arquivo_upload) {
            this.setState({ arquivoHelper: 'Selecione um arquivo' });
            return;
        }

        this.setState({ loadingArquivos: true });
        const formData = new FormData();
        formData.append('agendamento_id', agendamento_selecionado.id);
        formData.append('nome', arquivo_nome);
        formData.append('tipo', arquivo_tipo);
        formData.append('arquivo', arquivo_upload);
        
        const usuario = getCurrentUser();
        formData.append('cadastrado_por_id', usuario.id);
        
        // Adiciona a data atual formatada (necessário para o backend)
        const agora = moment().tz("America/Sao_Paulo");
        const dataHoraAtualFormatada = agora.format("YYYY-MM-DD HH:mm:ss");
        formData.append('data', dataHoraAtualFormatada);

        api.post('/agendamentos/arquivos/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(() => {
            this.setState({ loadingArquivos: false, showModalArquivosEdit: false });
            MySwal.fire({ icon: 'success', title: 'Sucesso', text: 'Arquivo enviado com sucesso!' });
            
            // Se o status for 'arquivo_pendente', atualiza para 'finalizado'
            if (agendamento_selecionado.situacao === 'arquivo_pendente') {
                const payloadStatus = { situacao: 'finalizado' };
                api.patch(`/agendamentos/${agendamento_selecionado.id}/`, payloadStatus).then(() => {
                     // Recarrega a lista principal para refletir a mudança de status
                     this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                }).catch(() => {
                     // Mesmo se falhar o patch (ex: já finalizado), tenta recarregar
                     this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                });
            } else {
                 // Se não era pendente, recarrega igual para garantir
                 this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
            }

            // Reabre o modal de listagem e recarrega os arquivos
            this.handleShowModalArquivos(agendamento_selecionado);
        }).catch(error => {
            this.setState({ loadingArquivos: false });
            console.error(error);
            MySwal.fire({ icon: 'error', title: 'Erro', text: 'Erro ao enviar arquivo.' });
        });
    };

    render() {
        if (!hasPerm('view_agendamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_user = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Agendamentos</h4>
                    </Col>
                    {this.state.dados_usuario['tipo_usuario'] != 'prestador' && this.state.dados_usuario['tipo_usuario'] != 'beneficiario' && (
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/agendamentos/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Agendamento
                        </Button>
                    </Col>
                    )}
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row className="mb-3">
                            <Col sm={12} md={6} lg={4} className="offset-lg-8 offset-md-6">
                                <Form.Group>
                                    <InputGroup>
                                        <InputGroup.Text className="bg-light border-end-0">
                                            <FaSearch className="text-muted" />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            placeholder="Buscar por Paciente..."
                                            value={this.state.busca}
                                            onChange={this.onChangeBusca}
                                            className="border-start-0 ps-0"
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Data do Agendamento</th>
                                    {dados_user['tipo_usuario'] != 'prestador' && (
                                    <th>Prestador</th>
                                    )}
                                    <th>Paciente</th>
                                    <th>Serviço/Procedimento</th>
                                    <th>Data de Solicitação</th>
                                    <th>Situação</th>
                                    <th>Envio Kit</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>

                {/* Modal de Confirmação de Realização de Serviço */}
                <ConfirmarRealizacaoModal
                    show={this.state.showConfirmarRealizacaoModal}
                    onHide={() => this.setState({ showConfirmarRealizacaoModal: false, agendamentoParaConfirmar: null })}
                    agendamento={{
                        ...this.state.agendamentoParaConfirmar,
                        dados_programa: this.state.agendamentoParaConfirmar?.dados_programa || this.state.agendamentoParaConfirmar?.dados_atendimento?.programa
                    }}
                    contextData={{
                        beneficiario_id: this.state.agendamentoParaConfirmar?.beneficiario_id,
                        atendimento_id: this.state.agendamentoParaConfirmar?.atendimento_id,
                        etapa_atual: this.state.agendamentoParaConfirmar?.etapa_atual,
                        prestador_nome: this.state.agendamentoParaConfirmar?.dados_prestador?.nome
                    }}
                    programa_config={this.state.agendamentoParaConfirmar?.dados_programa?.configuracoes || this.state.agendamentoParaConfirmar?.dados_atendimento?.programa?.configuracoes}
                    onSuccess={() => {
                        this.setState({ showConfirmarRealizacaoModal: false, agendamentoParaConfirmar: null });
                        window.location.reload();
                    }}
                />

                {/* Modal de Formulário Dinâmico de Serviços */}
                <ModalPersonalizadoServicos
                    show={this.state.showModalPersonalizadoServicos}
                    onHide={() => this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false })}
                    agendamento={this.state.agendamentoFormularioDinamico}
                    contextData={{
                        atendimento_id: this.state.agendamentoFormularioDinamico?.atendimento_id,
                        etapa_atual: this.state.agendamentoFormularioDinamico?.etapa_atual,
                    }}
                    onSuccess={() => {
                        this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false });
                        window.location.reload();
                    }}
                    readOnly={this.state.formularioDinamicoReadOnly}
                />

                {/* Modal de Arquivos */}
                <Modal size="xl" show={this.state.showModalArquivos} onHide={this.handleCloseModalArquivos}>
                    <Modal.Header closeButton>
                        <Modal.Title>Arquivos do Agendamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={12}>
                                <div className="row-list">
                                    <Form.Label className="mb-0">
                                        DADOS DO AGENDAMENTO
                                    </Form.Label>
                                    <hr className="mb-2 mt-1"></hr>
                                    <p className="mb-1">
                                        <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PACIENTE:</small> <strong>{this.state.agendamento_selecionado?.dados_beneficiario?.nome}</strong>
                                    </p>
                                    {this.state.agendamento_selecionado?.dados_beneficiario?.celular && (
                                        <p>
                                            <small>TELEFONE PACIENTE:</small> <strong>{this.state.agendamento_selecionado.dados_beneficiario.celular}</strong>
                                        </p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        {this.state.loadingArquivos ? (
                            <div className="text-center p-3">
                                <span className="spinner-border spinner-border-sm me-2"></span>Carregando arquivos...
                            </div>
                        ) : this.state.arquivos.length > 0 ? (
                            (() => {
                                const evt = this.state.agendamento_selecionado;
                                const config = evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes;
                                
                                const aprovaAutomatico = getConfig(config, 'aprova_laudo_automatico', true);
                                const showStatusColumn = !aprovaAutomatico;
                                
                                return (
                                <div className="table-responsive">
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Arquivo</th>
                                            <th className="text-nowrap">Data</th>
                                            <th className="text-nowrap">Tipo</th>
                                            {showStatusColumn && <th className="text-nowrap">Status</th>}
                                            { getCurrentUser().tipo_usuario !== 'prestador' && <th className="text-end text-nowrap" style={{ width: '1%' }}>Opções</th> }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.arquivos.map((arquivo) => {
                                            const dados_user = getCurrentUser();
                                            const usuarioLogadoId = String(dados_user.id);
                                            const arquivoAutorId = String(arquivo.cadastrado_por_id);
                                            const isAutor = usuarioLogadoId === arquivoAutorId;
                                            
                                            const validacaoArquivosHabilitada = getConfig(
                                                config, 
                                                'agendamento.validacao_arquivos', 
                                                false
                                            );

                                            const isNavegadora = ['', 'operador', 'gestor'].includes(dados_user.tipo_usuario);
                                            
                                            const podeAvaliar = (dados_user.tipo_usuario === '' || !isAutor) && arquivo.aprovado === null && isNavegadora;

                                            const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(config);

                                            return (
                                                <tr key={arquivo.id}>
                                                    <td>
                                                        {isBloqueadoVisualizarLaudo ? (
                                                            <span className="text-muted" title="Visualização bloqueada">
                                                                {arquivo.nome} <FaExclamationTriangle className="text-warning" />
                                                            </span>
                                                        ) : (
                                                            <a href={arquivo.arquivo} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                                {arquivo.nome} <FaDownload size={12} />
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td className="text-nowrap">{formataDataHoraExibicao(arquivo.data)}</td>
                                                    <td className="text-nowrap">{tiposArquivos[arquivo.tipo] || arquivo.tipo}</td>
                                                    {showStatusColumn && (
                                                        <td className="text-nowrap">
                                                            {arquivo.aprovado === true && <Badge bg="success">Aprovado</Badge>}
                                                            {(arquivo.aprovado === null || arquivo.aprovado === undefined) && <Badge bg="warning" text="dark">Pendente</Badge>}
                                                            {arquivo.aprovado === false && (
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{arquivo.motivo_recusa}</Tooltip>}>
                                                                    <Badge bg="danger" style={{ cursor: 'help' }}>Recusado <FaExclamationTriangle /></Badge>
                                                                </OverlayTrigger>
                                                            )}
                                                        </td>
                                                    )}
                                                    { getCurrentUser().tipo_usuario !== 'prestador' && (
                                                    <td className="text-end text-nowrap">
                                                        {/* Botões de Aprovar/Recusar - Superuser vê se tiver validacao habilitada (mesmo que seja autor, para teste) */}
                                                        {podeAvaliar && (
                                                            <>
                                                                <Button 
                                                                    variant="outline-success" 
                                                                    size="sm" 
                                                                    className="me-1" 
                                                                    onClick={() => this.handleAprovarArquivo(arquivo.id)}
                                                                    title="Aprovar"
                                                                >
                                                                    <FaCheck />
                                                                </Button>
                                                                <Button 
                                                                    variant="outline-danger" 
                                                                    size="sm" 
                                                                    className="me-1"
                                                                    onClick={() => this.handleRecusarArquivo(arquivo.id)}
                                                                    title="Recusar"
                                                                >
                                                                    <FaTimes />
                                                                </Button>
                                                            </>
                                                        )}

                                                        {/* Botões de Edição/Exclusão - Superuser vê SEMPRE junto com aprovação se quiser */}
                                                        {(dados_user['tipo_usuario'] == '' || dados_user['tipo_usuario'] === 'operador') && (
                                                            <>
                                                                <Button variant="outline-primary" size="sm" className="me-1" onClick={() => this.editarArquivo(arquivo)} title="Editar">
                                                                    <FaEdit />
                                                                </Button>
                                                                <Button variant="outline-danger" size="sm" onClick={() => this.excluirArquivo(arquivo.id)} title="Excluir">
                                                                    <FaTrash />
                                                                </Button>
                                                            </>
                                                        )}
                                                    </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                            );
                            })()
                        ) : (
                            <p className="text-center text-muted">Nenhum arquivo encontrado.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={this.handleCloseModalArquivos}>
                            Fechar
                        </Button>
                        {(() => {
                            const evt = this.state.agendamento_selecionado;
                            const configValidacao = getConfig(evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes, 'agendamento.validacao_arquivos', false);
                            
                            const user = getCurrentUser();
                            const podeAdicionar = (['operador', 'gestor', ''].includes(user.tipo_usuario) || (user.tipo_usuario === 'prestador' && configValidacao));
                            
                            const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(
                                evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes
                            );

                            return podeAdicionar && !isBloqueadoVisualizarLaudo && evt?.situacao !== "cancelado" && (
                                <Button variant="secondary" onClick={() => this.handleShowModalArquivosEdit()}>
                                    <FaPlus /> Cadastrar Novo Arquivo
                                </Button>
                            );
                        })()}
                    </Modal.Footer>
                </Modal>

                {/* Modal de Upload de Arquivo */}
                <Modal size="xl" show={this.state.showModalArquivosEdit} onHide={this.handleCloseModalArquivosEdit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Novo Arquivo - Agendamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <Row>
                            <Col sm={12}>
                                <div className="row-list mb-3">
                                    <Form.Label className="mb-0">
                                        DADOS DO AGENDAMENTO
                                    </Form.Label>
                                    <hr className="mb-2 mt-1"></hr>
                                    <p className="mb-1">
                                        <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PACIENTE:</small> <strong>{this.state.agendamento_selecionado?.dados_beneficiario?.nome}</strong>
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        <Form onSubmit={this.saveArquivo}>
                            <Row>
                                <Col sm={12} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Anexe abaixo um novo arquivo</Form.Label>
                                        <Form.Control type="file" onChange={this.onChangeArquivo} />
                                        <Form.Text className="text-danger">{this.state.arquivoHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control type="text" value={this.state.arquivo_nome} placeholder="Ex: Laudo X" onChange={e => this.handleChange(e, 'arquivo_nome')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" value={this.state.arquivo_tipo} onChange={e => this.handleChange(e, 'arquivo_tipo')}>
                                            <option value="">Selecione...</option>
                                            {Object.entries(tiposArquivos).map(([sigla, nome]) => (
                                                <option key={sigla} value={sigla}>{nome}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button type="submit" variant="secondary" disabled={this.state.loadingArquivos}>
                                    {this.state.loadingArquivos ? <span className="spinner-border spinner-border-sm me-2"></span> : <FaCheck className="me-1" />} 
                                    Enviar Arquivo
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Agendamentos);
